import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {applyMiddleware, createStore} from 'redux';
import reducer from './reducers/index';
import thunk from 'redux-thunk';
import {App, AppMobile} from "./containers/App";
// import registerServiceWorker from './registerServiceWorker';
import './index.css';
import {renderMobile} from "./constants/AppDimensions";
import {
  availabilityCustomerKeyChange,
  availabilityCriteriaChange,
  muiThemeChange
} from "./actions/AvailabilityActions";
import * as firebase from 'firebase';

// export const display = (elementId, propertyIds, customer_key, muiTheme) => {
export const display = (options) => {
  const store = createStore(
      reducer,
      window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
      applyMiddleware(thunk)
  );

  updateMuiTheme(store, options.muiTheme);

  updateCriteria(store, options.propertyIds);

  updateCustomerKey(store, options.key);

  const app = renderMobile ? <AppMobile/> : <App/>;

  // let config = {
  //   apiKey: "AIzaSyCTqcYkvAFngVqq6qh5O5RssouxM3SgRYg",
  //   authDomain: "my-project-1485783740290.firebaseapp.com",
  //   databaseURL: "https://my-project-1485783740290.firebaseio.com",
  //   projectId: "my-project-1485783740290",
  // };

  let config = {
    apiKey: "AIzaSyCGJ436UR3dbXGJOAlY6uCOs5vDuiNb85Q",
    authDomain: "hti-customer-app.firebaseapp.com",
    databaseURL: "https://hti-customer-app.firebaseio.com",
    projectId: "hti-customer-app",
  };

  if (!firebase.apps.length) { // only init once
    firebase.initializeApp(config);
  }

  // try {
  //   firebase.initializeApp(config);
  // } catch (error) {
  //   // we skip the "already exists" message which is
  //   // not an actual error when we have multiple apps running
  //   if (!/already exists/.test(error.message)) {
  //     console.error('Firebase initialization error', error.stack)
  //   }
  // }

  firebase.auth().signInAnonymously().catch(error => {
    // do something with error
  });

  ReactDOM.render(
      <Provider store={store}>
        {app}
      </Provider>, document.getElementById(options.elementId));
  // registerServiceWorker();
};

const updateMuiTheme = (store, muiTheme) => {
  if(muiTheme !== undefined) {
    store.dispatch(muiThemeChange(muiTheme));
  }
};

const updateCriteria = (store, propertyIds) => {
  store.dispatch(availabilityCriteriaChange({
    ...store.getState().availabilityReducer.criteria,
    properties: propertyIds.map(id => {
      return({id: id})
    })
    //[{id: 7}, {id: 4}, {id: 10}, {id: 6}, {id: 2}, {id: 3}],
    // properties: [{id: propertyId}, {id: 6}, {id: 8}, {id: 9}, {id: 20},
    //   {id: 14}, {id: 11}, {id: 19}, {id: 15}, {id: 16}, {id: 17}, {id: 18}],
    // currency: currency
  }));
};

const updateCustomerKey = (store, customer_key) => {
  store.dispatch(availabilityCustomerKeyChange(customer_key))
};


// WEBPACK FOOTER //
// ./src/AvailNow.js